import { contactInsurance, contactMedicalExamination, contactSubscription } from "../../../model/contactsubscription";
import { subscription } from "../../../model/subscription";

export interface IState {
    contactSubscriptions: Array<contactSubscription>;
    contactMedical: Array<contactMedicalExamination>;
    contactInsurances: Array<contactInsurance>;
    subscriptions: Array<subscription>;
    selectedSubscription?: subscription;
    isLoading: boolean;
    isLoadingSubscriptions: boolean;
    isNewSubscription: boolean;
}

export const DefaultState = (): IState => ({
    contactSubscriptions: [],
    contactMedical: [],
    contactInsurances: [],
    subscriptions: [],
    selectedSubscription: undefined,
    isLoading: false,
    isLoadingSubscriptions: false,
    isNewSubscription: false,
})